enum PortalDialogType {
	CONVERT = "convert",
	ROTATE = "rotate",
	ORIENTATION = "orientation",
	DELETE = "delete",
	UPLOAD = "upload",
	RENAME = "rename",
	PRINT = "print",
	DELETE_PAGE = "delete_page",
	SPLIT = "split",
	WATERMARK = "watermark",
	ATTACHMENT_ADD = "attachment_add",
	ATTACHMENT_ADD_GLOBAL = "attachment_add_global",
	ATTACHMENT_EXTRACT = "attachment_extract",
	ATTACHMENT_DELETE = "attachment_delete",
	EXTRACT_CONTENT = "extract_content",
	EXTRACT_IMAGES = "extract_images",
	EXTRACT_INFO = "extract_info",
	EXTRACT_PAGE = "extract_page",
	BACKGROUND = "background",
	HEADER_FOOTER = "header_footer",
	DESCRIPTION = "description",
	VIEW = "view",
	BOXES = "boxes",
	TRANSITION = "transition",
	ADD_PAGE = "add_page",
	PDFA = "pdfa",
	OCR = "ocr",
	SIGNATURE = "signature",
	FLATTEN_FORMS = "flatten_forms",
	EXTRACT_FORMS = "extract_forms",
	IMPORT_FORMS = "import_forms",
	EDIT_FORMS = "edit_forms",
	SANITIZE = "sanitize",
	REDACT_AREA = "redact_area",
	REDACT_TEXT = "redact_text",
	REDACT_PAGE = "redact_page",
	REDACT = "redact",
	REDACT_EDIT = "redact_edit",
	ADD_OUTLINE = "add_outline",
	REMOVE_OUTLINE = "remove_outline",
	BARCODE_CREATE = "barcode_create",
	BARCODE_CREATE_AREA = "barcode_create_area",
	BARCODE_CREATE_SWISS_QR = "barcode_create_swiss_qr",
	BARCODE_CREATE_SWISS_QR_AREA = "barcode_create_swiss_qr_area",
	BARCODE_DETECT = "barcode_detect",
	BARCODE_SWISS_QR_CODE_FORM = "barcode_swiss_qr_code_form",
	ANNOTATION_NOTE = "annotation_note",
	ANNOTATION_NOTE_EDIT = "annotation_note_edit",
	ANNOTATION_MARK = "annotation_mark",
	ANNOTATION_MARK_EDIT = "annotation_mark_edit",
	ANNOTATION_STRIKE = "annotation_strike",
	ANNOTATION_STRIKE_EDIT = "annotation_strike_edit",
	ANNOTATION_UNDERLINE = "annotation_underline",
	ANNOTATION_UNDERLINE_EDIT = "annotation_underline_edit",
	ANNOTATION_SQUIGGLY = "annotation_squiggly",
	ANNOTATION_SQUIGGLY_EDIT = "annotation_squiggly_edit",
	ANNOTATION_DELETE = "annotation_delete",
	ANNOTATION_LINE = "annotation_line",
	ANNOTATION_LINE_EDIT = "annotation_line_edit",
	ANNOTATION_SQUARE = "annotation_square",
	ANNOTATION_SQUARE_EDIT = "annotation_square_edit",
	ANNOTATION_CIRCLE = "annotation_circle",
	ANNOTATION_CIRCLE_EDIT = "annotation_circle_edit",
	ANNOTATION_REPLY = "annotation_reply",
	ANNOTATION_REPLY_EDIT = "annotation_reply_edit",
	ANNOTATION_STAMP = "annotation_stamp",
	ANNOTATION_STAMP_EDIT = "annotation_stamp_edit",
	ANNOTATION_FLATTEN = "annotation_flatten",
	MERGE = "merge",
	PORTFOLIO_CREATE = "portfolio_create",
	PORTFOLIO_ADD_FILE = "portfolio_add_file",
	PORTFOLIO_ADD_FOLDER = "portfolio_add_folder",
	PORTFOLIO_REMOVE = "portfolio_remove",
	PORTFOLIO_EXTRACT = "portfolio_extract",
	ENCRYPT = "encrypt",
	CERTIFICATE_ENCRYPT = "certificate_encrypt",
	DECRYPT = "decrypt",
	URLCONVERTER = "urlconverter",
	MOVE = "move",
	COMPRESS = "compress",
	SCALE = "scale",
	EXTRACT_HTML = "extract_html",
	SETTINGS_CERTIFICATE = "settings_certificate",
	ZIP_CONFIRMATION = "zip_confirmation",
	SIGNATURE_REMOVE = "signature_remove"
}

export default PortalDialogType;